module.exports = __webpack_public_path__ + "img/protocols.a7e6cf21.svg";